import { render, staticRenderFns } from "./QianchuanScheduleTask.vue?vue&type=template&id=515d1f06&scoped=true"
import script from "./QianchuanScheduleTask.vue?vue&type=script&lang=js"
export * from "./QianchuanScheduleTask.vue?vue&type=script&lang=js"
import style0 from "./QianchuanScheduleTask.vue?vue&type=style&index=0&id=515d1f06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515d1f06",
  null
  
)

export default component.exports